const AUTH_COOKIE_NAME = 'KeyAuth';
/**
 * Get the cookie name and auth url to use for the current environment based on the hostname.
 *
 * TODO: HATE that the authClientUrl's are hardcoded here.
 *
 * @returns The cookie name and auth url for the current environment.
 */
export default function getAuthEnvironmentVariables() {
    const hostname = window.location.hostname;
    if (hostname.includes('localhost')) {
        return {
            cookieName: `dev${AUTH_COOKIE_NAME}`,
            authClientUrl: 'http://localhost:3006',
        };
    }
    if (hostname.includes('demo')) {
        return {
            cookieName: `demo${AUTH_COOKIE_NAME}`,
            authClientUrl: 'https://accounts-demo.keyown.com',
        };
    }
    if (hostname.includes('staging')) {
        return {
            cookieName: `staging${AUTH_COOKIE_NAME}`,
            authClientUrl: 'https://accounts-staging.keyown.com',
        };
    }
    return {
        cookieName: `prod${AUTH_COOKIE_NAME}`,
        authClientUrl: 'https://accounts.keyown.com',
    };
}
//# sourceMappingURL=index.js.map